import { useApi } from '@omnipresentgroup/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, CLIENT_POLICY_API_PATH } from '../constants';

export const useDeleteClientPolicyMutation = () => {
  const { DELETE } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      clientId,
      countryCode,
    }: {
      clientId: string;
      countryCode: string;
    }) => {
      return DELETE(
        `${API_BASE}/${CLIENT_POLICY_API_PATH}/${clientId}?country_code=${countryCode}`,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CLIENT_POLICY_API_PATH],
        refetchType: 'all',
      });
    },
  });
};
